import { Paper, Stack, Box } from '@mui/material'
import React, { useEffect, useState } from 'react'
import DetailsBox from '../../../components/Cards/DetailsBox'
import CustomDataGrid from '../../../components/DataGrid/CustomDataGrid'
import API from '../../../services/API'
import moment from 'moment'
import CheckCircle from '@mui/icons-material/CheckCircle'
import { useNavigate } from 'react-router-dom'

const Events = ({ clientID }) => {
  const [events, setEvents] = useState([])
  const [loading, setLoading] = useState(true)

  useEffect(() => {
    if (clientID) {
      API.get('/event-planning/organisations/events/' + clientID)
        .then((res) => res.status === 200 && setEvents(res.data))
        .finally(() => setLoading(false))
    }
  }, [clientID])

  const navigate = useNavigate()

  return (
    <DetailsBox title="Events">
      <CustomDataGrid
        loading={loading}
        rows={events}
        getRowId={(params) => params._id}
        localeText={{ noRowsLabel: 'No Events' }}
        columns={[
          {
            field: 'startDate',
            headerName: 'Date',
            minWidth: 150,
            renderCell: ({ value }) => moment(value).format('Do MMM YYYY'),
          },
          {
            field: 'title',
            headerName: 'Event Name',
            minWidth: 250,
            flex: 1,
          },
          { field: 'status', headerName: 'Status', minWidth: 100 },
          {
            field: 'eventLocation',
            headerName: 'Location',
            minWidth: 200,
            flex: 0.8,
          },
          {
            field: 'EMPApproved',
            headerName: 'EMP',
            minWidth: 100,
            renderCell: ({ value }) => value && <CheckCircle color="success" />,
          },
          {
            field: 'invoicePaid',
            headerName: 'Paid',
            minWidth: 100,
            renderCell: ({ row }) =>
              row.invoicePaid && <CheckCircle color="success" />,
          },
        ]}
        disableRowSelectionOnClick
        onRowClick={({ row }) => navigate('/events/' + row._id)}
      />
    </DetailsBox>
  )
}

export default Events
